/* eslint-disable @typescript-eslint/naming-convention */
import { ModelValidationMetadataMap } from 'app/core/validation';

export const timeImportValidationMetadata: ModelValidationMetadataMap = {
  TimeEntryImportDetail: {
    validators: [
      {
        group: 'Errors',
        validators: [
          {
            name: 'expression',
            context: {
              messageTemplate: 'Total billed and written off amounts cannot exceed the total amount.',
              expression: 'Math.abs(model.timeEntryImportBillDetails.reduce((prev, curr) => prev + (curr.billedTotal || 0) + (curr.writeOffTotal || 0), 0)) <= Math.abs(model.total || 0)'
            }
          }
        ]
      }
    ],
    properties: {
      category1Id: {
        validators: [
          {
            group: 'Errors',
            validators: [
              {
                name: 'required',
                condition: 'model.category1',
                context: {
                  messageTemplate: 'No match found for Category 1. Please manually select a category.'
                }
              }
            ]
          }
        ]
      },
      category2Id: {
        validators: [
          {
            group: 'Warnings',
            validators: [
              {
                name: 'required',
                condition: 'model.category2',
                context: {
                  messageTemplate: 'No match found for Category 2. Please manually select a category.'
                }
              }
            ]
          }
        ]
      },
      category3Id: {
        validators: [
          {
            group: 'Warnings',
            validators: [
              {
                name: 'required',
                condition: 'model.category3',
                context: {
                  messageTemplate: 'No match found for Category 3. Please manually select a category.'
                }
              }
            ]
          }
        ]
      },
      total: {
        validators: [
          {
            group: 'Errors',
            validators: [
              {
                name: 'required',
                context: {
                  messageTemplate: 'The total amount is required. Please manually enter an amount.'
                }
              },
              // {
              //   name: 'expression',
              //   context: {
              //     messageTemplate: 'The total amount must be greater than zero.',
              //     expression: 'context.value == null || context.value > 0'
              //   }
              // }
            ]
          }
        ]
      },
    }
  },
  TimeEntryImportBillDetail: {
    properties: {
      billedTotal: {
        validators: [
          {
            group: 'Errors',
            validators: [
              {
                name: 'required',
                context: {
                  messageTemplate: 'The billed amount is required. Please manually enter an amount.'
                }
              }
            ]
          }
        ]
      }
    }
  }
};
